import { candleParser } from '../candleParser';

/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645475936868,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","candleColor":"GREEN","candleType":"LAST"},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"BREAK_CANDLE_TYPE","symbol":"XYZ"},
	"date": "2022-02-21T15:38:57.475-0500",
	"timestamp": "1645475937475"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 * 4) candleColor
 * 5) candleType
 */
export function breakCandleType(pluginTemplate) {
  const parsedObject = {
    candleDuration: null,
    timeUnit: null,
    candle: null,
    candleColor: null,
    candleType: null,
  };
  if (pluginTemplate) {
    parsedObject.candleDuration = pluginTemplate.candleDuration ?? null;
    parsedObject.timeUnit = pluginTemplate.timeUnit ?? null;
    parsedObject.candleColor = pluginTemplate.candleColor ?? null;
    parsedObject.candleType = pluginTemplate.candleType ?? null;
    const candle = candleParser(pluginTemplate.candle) ?? null;
    if (candle) {
      parsedObject.candle = candle;
    }
  }
  return parsedObject;
}
